// src/streaming/streamSwClient.js

let swReadyPromise = null;
let messageListeners = new Set();

function ensureReady() {
  if (!("serviceWorker" in navigator)) {
    return Promise.reject(new Error("Service Worker not supported"));
  }

  if (!swReadyPromise) {
    swReadyPromise = navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/stream-sw.js`)
      .then(() => navigator.serviceWorker.ready);
  }
  return swReadyPromise;
}

export async function initStreamSW() {
  const registration = await ensureReady();

  // Global message listener only once
  if (!navigator.serviceWorker._streamListenerAttached) {
    navigator.serviceWorker.addEventListener("message", (event) => {
      const data = event.data;
      if (!data || !data.type) return;

      messageListeners.forEach((cb) => cb(data));
    });
    navigator.serviceWorker._streamListenerAttached = true;
  }

  return registration;
}

export function addStreamListener(callback) {
  messageListeners.add(callback);
  return () => messageListeners.delete(callback);
}

async function postToSW(message) {
  const registration = await ensureReady();
  const target =
    registration.active || navigator.serviceWorker.controller;

  if (!target) {
    throw new Error("No active Service Worker");
  }
  target.postMessage(message);
}


async function resumeToSW(message) {
  const registration = await ensureReady();
  const target =
    registration.active || navigator.serviceWorker.controller;

  if (!target) {
    throw new Error("No active Service Worker");
  }
  target.postMessage(message);
}

export async function startStream(sessionId, url, payload) {
  console.log("sapiiiii",payload)
  await postToSW({
    type: "START_STREAM",
    sessionId,
    url,
    payload,
  });
}

export async function resumeStream(sessionId){
   await resumeToSW({
    type: "RESUME_STREAM",
    sessionId
  });
}

export async function stopStream(sessionId) {
  await postToSW({
    type: "STOP_STREAM",
    sessionId,
  });
}

export async function requestLastSeen(sessionId) {
  await postToSW({
    type: "STREAM_LASTSEEN",
    sessionId,
  });
}



export async function startPhoneStream(apolloId,independent) {

  await postToSW({
    type: "START_PHONE_STREAM",
    apolloId,
    independent
  })
}

export async function stopPhoneStream(apolloId) {
   await postToSW({
    type: "STOP_PHONE_STREAM",
    apolloId,
  })
}
